module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong--dark-faeca84ca071f20ba7fce4240860cebc.png";